import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Bar, mixins } from 'vue-chartjs'
import { IChartData } from '@/types'
const { reactiveProp } = mixins

@Component({
	mixins: [reactiveProp]
})

export default class BarChart extends Mixins(Bar) {

	@Prop()
	private chartData!: IChartData;

	@Prop()
	private chartOptions!: any;

	mounted() {
		this.renderChart(this.chartData, this.chartOptions);
	}
}